import React from 'react';

import styles from './NoData.module.css';

interface INoDataProps {
  img: string;
  title: string;
  subtitle: string;
}

const NoData = ({ img, title, subtitle }: INoDataProps) => (
  <div className={styles.container}>
    <div className={styles.contentWrapper}>
      <div className={styles.imgWrapper}>
        <img src={img} alt="No data icon" />
      </div>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.subTitle}>{subtitle}</div>
    </div>
  </div>
);

export default NoData;
